module.exports = __webpack_public_path__ + "static/media/premiereFois_01_thumb.20a547fc.png";